/**
 * Menu Dropdown Component
 * 
 * Hamburger menu with import/export options.
 */

import React from 'react';
import { Upload, Download } from 'lucide-react';
import { ABLE_COLORS, APP_VERSION } from '../../constants';

export default function MenuDropdown({
  showMenu,
  setShowMenu,
  onExport,
  onOpenImport
}) {
  if (!showMenu) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.3)',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        padding: '20px'
      }}
      onClick={() => setShowMenu(false)}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '20px',
          padding: '16px',
          minWidth: '200px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => {
            onOpenImport();
            setShowMenu(false);
          }}
          style={{
            width: '100%',
            padding: '12px 16px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left',
            fontSize: '16px',
            color: '#333',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = ABLE_COLORS.bg}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          <Upload size={20} color={ABLE_COLORS.primary} />
          Import Data
        </button>
        <button
          onClick={() => {
            onExport();
            setShowMenu(false);
          }}
          style={{
            width: '100%',
            padding: '12px 16px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left',
            fontSize: '16px',
            color: '#333',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = ABLE_COLORS.bg}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          <Download size={20} color={ABLE_COLORS.primary} />
          Export Data
        </button>
        <div style={{
          padding: '12px 16px',
          borderTop: '1px solid ' + ABLE_COLORS.bg,
          marginTop: '8px',
          fontSize: '12px',
          color: '#999',
          textAlign: 'center'
        }}>
          v{APP_VERSION}
        </div>
      </div>
    </div>
  );
}
